(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ovyre-cart-picks"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ovyre-cart-picks')) {

  customElements.define(
    'ovyre-cart-picks',

    class extends HTMLElement {

      connectedCallback() {

        /*
         * Stop PHX cart-drawer listeners from interfering
         * with our upsell variant selector.
         */

        /*
         * Update 10% upsell pricing when
         * a customer changes color / size.
         */

        const updateUpsellPrice = (select) => {

          if (!select) {
            return;
          }

          const card =
            select.closest(
              '.ovyre-cart-pick'
            );

          const selectedOption =
            select.options[
              select.selectedIndex
            ];

          if (
            !card ||
            !selectedOption
          ) {
            return;
          }


          const regularPrice =
            card.querySelector(
              '[data-regular-price]'
            );

          const salePrice =
            card.querySelector(
              '[data-sale-price]'
            );

          const savings =
            card.querySelector(
              '[data-savings]'
            );


          if (regularPrice) {
            regularPrice.textContent =
              selectedOption.dataset.regularPrice ||
              '';
          }


          if (salePrice) {
            salePrice.textContent =
              selectedOption.dataset.salePrice ||
              '';
          }


          if (savings) {
            savings.textContent =
              'You save ' +
              (
                selectedOption.dataset.savings ||
                ''
              );
          }

        };


        /*
         * Set correct prices immediately
         * when the cart drawer loads.
         */

        this
          .querySelectorAll(
            '.ovyre-cart-pick__select'
          )
          .forEach((select) => {

            updateUpsellPrice(select);

          });


        /*
         * Variant change
         */

        this.addEventListener(
          'change',
          (event) => {

            if (
              event.target.matches(
                '.ovyre-cart-pick__select'
              )
            ) {

              event.stopPropagation();

              updateUpsellPrice(
                event.target
              );

            }

          }
        );


        /*
         * AJAX ADD TO CART
         */

        this.addEventListener(
          'submit',
          async (event) => {

            const form = event.target;

            if (
              !form ||
              form.tagName !== 'FORM' ||
              !form.closest('.ovyre-cart-pick')
            ) {
              return;
            }

            event.preventDefault();
            event.stopPropagation();


            const button =
              form.querySelector(
                '.ovyre-cart-pick__add'
              );

            const buttonText =
              button?.querySelector(
                '.ovyre-cart-pick__add-text'
              );

            const status =
              this.querySelector(
                '.ovyre-cart-picks__status'
              );


            if (
              !button ||
              button.disabled
            ) {
              return;
            }


            const originalText =
              buttonText
                ? buttonText.textContent
                : 'ADD TO CART';


            /*
             * Loading state
             */

            button.disabled = true;

            form.setAttribute(
              'aria-busy',
              'true'
            );

            if (buttonText) {
              buttonText.textContent =
                'ADDING...';
            }

            if (status) {
              status.textContent = '';
            }


            /*
             * Locate PHX cart drawer
             */

            const drawer =
              this.closest(
                'cart-drawer'
              );


            /*
             * Build Shopify Cart API request
             */

            const data =
              new FormData(form);

            data.set(
              'sections',
              'cart-drawer,cart-icon-bubble'
            );

            data.set(
              'sections_url',
              window.location.pathname
            );


            try {

              const response =
                await fetch(
                  this.dataset.addUrl + '.js',
                  {
                    method: 'POST',

                    headers: {
                      Accept:
                        'application/json'
                    },

                    body: data
                  }
                );


              const result =
                await response.json();


              if (
                !response.ok ||
                result.status
              ) {

                throw new Error(
                  result.description ||
                  result.message ||
                  this.dataset.error
                );

              }


              /*
               * Success message
               */

              if (status) {

                status.textContent =
                  this.dataset.added;

              }


              /*
               * Refresh PHX drawer using
               * its native renderContents method.
               */

              if (
                drawer &&
                typeof drawer.renderContents ===
                  'function' &&
                result.sections
              ) {

                drawer.classList.remove(
                  'is-empty'
                );

                drawer.renderContents(
                  result
                );

              } else {

                /*
                 * Fallback if theme's drawer
                 * cannot rerender.
                 */

                const fallback =
                  this.querySelector(
                    '.ovyre-cart-picks__fallback'
                  );

                if (fallback) {
                  fallback.hidden = false;
                }

              }


            } catch (error) {

              console.error(
                'OVYRE upsell add-to-cart error:',
                error
              );


              if (status) {

                status.textContent =
                  error.message ||
                  this.dataset.error;

              }


              button.disabled = false;


              if (buttonText) {

                buttonText.textContent =
                  originalText;

              }


            } finally {

              form.removeAttribute(
                'aria-busy'
              );

            }

          }
        );

      }

    }

  );

}
  } catch(e) { console.error(e); }
})();

})();
